import {
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { FilesInterface } from "../../interface/filesInterface";
import { FILE_ID_URL } from "../../services/endpoints";
import { FILE_TYPES } from "../../assets/data/fileTypes";
import axiosInstance from "../../services/axios-instance";
import { useContext } from "react";
import { DataContext } from "../../context/data-provider";
import { ROLES } from "../../assets/data/roles";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    fontWeight: "bold",
    color: theme.palette.text.primary,
}));
const StyledTableRow = styled(TableRow)(() => ({
    backgroundColor: "white",
}));

interface CellNamesParams {
    cellOne: string;
    cellTwo: string;
    cellTree: string;
    cellFour: string;
    cellFive?: string;
}

interface TableFilesParams {
    data: FilesInterface[];
    cellNames: CellNamesParams;
    setAllFiles?: React.Dispatch<React.SetStateAction<FilesInterface[]>>;
}
const TableFiles = ({ data, cellNames, setAllFiles }: TableFilesParams) => {
    const { currentUser } = useContext(DataContext);
    const handleFileDelete = async (id: number) => {
        try {
            await axiosInstance.delete(FILE_ID_URL(id));

            // Remove the deleted item from the allFiles array
            const updatedFiles = data.filter((file) => file.id !== id);

            // Update the state with the updated allFiles array
            setAllFiles && setAllFiles(updatedFiles);
        } catch (error) {
            console.error("Error deleting file:", error);
        }
    };

    const isAdmin = currentUser.role_id === ROLES.ADMIN;
    const isSuperAdmin = currentUser.role_id === ROLES.SUPER_ADMIN;
    const anyAdmin = isAdmin || isSuperAdmin;
    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow
                        sx={{
                            backgroundColor: "#f9fafc",
                        }}
                    >
                        <StyledTableCell>{cellNames.cellOne}</StyledTableCell>
                        <StyledTableCell>{cellNames.cellTwo}</StyledTableCell>
                        <StyledTableCell>{cellNames.cellTree}</StyledTableCell>
                        <StyledTableCell>{cellNames.cellFour}</StyledTableCell>
                        <StyledTableCell>{cellNames.cellFive}</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row: FilesInterface) => (
                        <StyledTableRow key={row.id}>
                            <TableCell>{row.title}</TableCell>
                            <TableCell>{row.description}</TableCell>
                            <TableCell>{FILE_TYPES[row.type]}</TableCell>
                            <TableCell>
                                <Button variant="contained" color="info">
                                    <a
                                        href={`${
                                            import.meta.env.VITE_BASE_URL
                                        }/api${FILE_ID_URL(row.id)}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: "white" }}
                                    >
                                        View
                                    </a>
                                </Button>
                            </TableCell>
                            {anyAdmin && (
                                <TableCell>
                                    <Button
                                        variant="contained"
                                        color="error"
                                        onClick={() => handleFileDelete(row.id)}
                                    >
                                        Delete
                                    </Button>
                                </TableCell>
                            )}
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default TableFiles;
